<div class="time-container">
  <div class="time">
    {{toTime()}},
  </div>
  <div>
    {{toDate()}}
  </div>
</div>

<div class="outer-container">
  <div class="info-container">

    <div class="back">
      <button class="back-btn" type="button" (click)="goBack()">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="70" height="50" fill="#D59805" class="bi bi-arrow-left-short" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/> </svg> -->

        <svg width="34" height="34" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.939339 10.9393C0.353554 11.5251 0.353554 12.4749 0.939339 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807612 11.0711 0.807612 10.4853 1.3934L0.939339 10.9393ZM33.5 10.5L2 10.5L2 13.5L33.5 13.5L33.5 10.5Z"
            fill="#E9AB09" />
        </svg>


      </button>
    </div>

    <div class="date-info-container">

      <div class="parent-date">
        <button class="nav-btn" type="button" (click)="offsetDecrease()">

          <svg width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 0-.708 0L4 8.293l6.646 6.647a.5.5 0 0 0 .708-.708L5.707 8l5.647-5.646a.5.5 0 0 0 0-.708z" />
          </svg>
        </button>

        <input class="date-input" [max]="today.toFormat('yyyy-MM-dd')" (change)="onDateChange($event)" type="date"
          value="{{displayDate.toFormat('yyyy-MM-dd')}}">
        <!-- <input class="date-input" type="text" value="{{ today.toFormat('d-MMMM-yyyy')}}"> -->

        <button class="nav-btn" type="button" (click)="offsetIncrease()" [disabled]="disableNext()">
          <svg width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0L12 8.293l-6.646 6.647a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>

      </div>

    </div>

    <div class="report">
      Report
    </div>

    <div>
      <select name="bid-category" class="form-control" (change)="onFilter($event)">
        <option *ngFor="let item of filter" [value]="item" [selected]="item===defaultFilter">
          {{item}}
        </option>
      </select>
    </div>

    <div>
      <button class="download-btn" type="button" (click)="downloadReport()">Download Report</button>
    </div>

  </div>

  <div class="history-container">
    <div class="table-container" *ngIf="dataList.length > 0">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Customer Name(ID)</th>
            <th>Bid type</th>
            <th>Bid Price</th>
            <th>Units</th>
            <th>Strike Price</th>
            <th>Allocated Units</th>
            <th>Untraded Units</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let transaction of dataList; let i = index">
            <td>{{i + 1}}</td>
            <td>{{transaction.customer_name}} ({{transaction.customer_id}})</td>
            <td>{{transaction.bid_type}}</td>
            <td>{{transaction.price}}</td>
            <td>{{transaction.units}}</td>
            <td>{{transaction.strike_price}}</td>
            <td>{{transaction.allotted_units}}</td>
            <td>{{transaction.untraded_units}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="no-data" *ngIf="dataList.length === 0">No data available.</div>
  </div>
</div>
